export enum Permission {
  Achievements = 'Achievements',
  Activities = 'Activities',
  Badges = 'Badges',
  Blocked = 'Blocked',
  GCoins = 'GCoins',
  GCoinsWithdrawal = 'GCoins_Withdrawal',
  GCoinsCustomAward = 'GCoins_CustomAward',
  General = 'General',
  ModuleRewardGeek = 'Module_RewardGeek',
  ModuleFeedback = 'Module_Feedback',
  ModuleOpportunity = 'Module_Opportunity',
  ModuleAdmin = 'Module_Admin',
  ActivitiesManage = 'Activities_Manage',
  GCoinsManage = 'GCoins_Manage',
  NewsManage = 'News_Manage',
  GeeksManage = 'Geeks_Manage',
  AchievementsManage = 'Achievements_Manage',
  SeasonsManage = 'Seasons_Manage',
  OpportunityCreate = 'Opportunity_Create',
  OpportunityManage = 'Opportunity_Manage',
  OpportunityGrantRoles = 'Opportunity_GrantRoles',
  OpportunityGrantRoleNone = 'Opportunity_GrantRoleNone',
  OpportunityGrantRoleCandidate = 'Opportunity_GrantRoleCandidate',
  OpportunityGrantRoleIssuer = 'Opportunity_GrantRoleIssuer',
  OpportunityGrantRoleApprover = 'Opportunity_GrantRoleApprover',
  OpportunityGrantRoleAdmin = 'Opportunity_GrantRoleAdmin',
  OpportunityApproveReject = 'Opportunity_Approve_Reject',
  OpportunityReports = 'Opportunity_Reports',
  Scores = 'Scores',
}
